import machineState from './machine-state';
import viewer3d from './viewer3d';
import * as probing from './probing';

export const EPS = .000001; // epsilon, for floating point comparisons

const constants = {
  machineState,
  viewer3d,
  probing
};

export default constants;
